import React, { useState, useContext, useEffect } from 'react';
import { Modal, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import Loader from '../../../../../../components/Loaders/Loader';
import { MainContext } from '../../../index';

import { modalClose } from '../../../reducer';
import { delay, getErrorMessage } from '../../../../../../utils/helper';
import ModalPreloader from '../../../../../../components/Modal/Preloader';
import CountDown from '../../../../../../components/CountDown';
import { superDetailsRefillUrl } from '../../../../../../services/endpoints/refill';

const ModalSuperAdminDetails = () => {
  const [store, dispatch] = useContext(MainContext);
  const { modal } = store;

  const [form, setForm] = useState({
    isLoading: false,
    error: null,
    success: false,
    init: false,
    details: [],
  });
  const { isLoading, init, details, error } = form;

  const onInit = async () => {
    try {
      const response = await superDetailsRefillUrl(modal.data.id);

      await delay(500);
      setForm((prevState) => ({
        ...prevState,
        isLoading: false,
        init: true,
        error: null,
        details: response?.data,
      }));
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setForm((prevState) => ({
        ...prevState,
        isLoading: false,
        init: true,
        error: errorMessage,
      }));
    }
  }

  useEffect(() => {
    onInit()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onCloseModal = () => {
    dispatch(modalClose())
  }

  return (
    <div>
      <Modal.Header closeButton={!isLoading && init}>
        <Modal.Title>Details</Modal.Title>
      </Modal.Header>
      <ModalPreloader
        isLoading={!init}
      >
        <Modal.Body>
          {isLoading ? <Loader success={form.success} /> : null }
          {error ? <div className="alert alert-danger">{error}</div> : null}
          {init && !error
            ? (
              <>
                {details?.map((detail, index) => {
                  if (detail.fieldKey === 'content' && isEmpty(detail.value)) return null;

                  return (
                    <FormGroup key={index}>
                      {detail.label && <ControlLabel>{detail.label}</ControlLabel>}
                      <FormControl rows={7} componentClass={detail.type} name={detail.name} readOnly value={detail.value} />
                    </FormGroup>
                  )
                })}
              </>
            ) : null}
        </Modal.Body>
        <Modal.Footer className="custom__modal-footer">
          <Button
            disabled={isLoading}
            onClick={onCloseModal}
          >
            Close
            {' '}
            {init && error ? (
              <>
                (
                <CountDown seconds={5} onComplete={onCloseModal} />
                )
              </>
            ) : null}
          </Button>
        </Modal.Footer>
      </ModalPreloader>
    </div>
  )
};

ModalSuperAdminDetails.propTypes = {

};

export default ModalSuperAdminDetails;
